// Dileep

import { useState, useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getBlogDetails } from "../services/blogPostService";
import { capitalizeWordsRemoveDash, limitChars } from "../../../../../utils/text.utils";

function useBlogPost() {
  const location = useLocation();
  const navigate = useNavigate();
  const { blog } = useParams();
  const blogSlug = location.state?.blog || blog || null;
  const [data, setData] = useState(null);
  const currentUrl = window.location.href;
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
  const instagramShareUrl = `https://www.instagram.com/?url=${encodeURIComponent(currentUrl)}`;

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [blogSlug]);

  useEffect(() => {
    if (blogSlug) fetchBlog(blogSlug);
  }, [blogSlug]);

  const fetchBlog = async (slug) => {
    try {
      const blogData = await getBlogDetails(slug);
      setData(blogData);
    } catch (err) {
      console.log("Failed to load blog:", err);
    }
  };

  const handleBlogClick = (slug) => {
    navigate("/blog", { state: { blog: slug } });
  };

  // Youtube Frame 

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return "";
    const cleanUrl = url.trim();
    if (cleanUrl.includes("/embed/")) return cleanUrl;

    const match = cleanUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : "";
  };

  //  Breadcrumb path

  const breadcrumbPaths = [
    { label: "Blog", to: "/blog" },
    { label: capitalizeWordsRemoveDash(limitChars(blogSlug, 35)), to: "" },
  ];

  return { data, handleBlogClick, instagramShareUrl, facebookShareUrl, getYoutubeEmbedUrl, breadcrumbPaths };
}

export default useBlogPost;
